import React, { useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import { monthData } from '../../Constants/constants';
import { formatDate } from '../../Components/InputElements';
const BasicInformation = ({employeeBasicData,joinDate}) => {
    const { apiURL, apiHeaderJSON, employee_id } = useContext(ConfigContext);
    // const [employeeBasicData, setEmployeeBasicData] = useState({});
    const [employeeOtherData, setEmployeeOtherData] = useState({});
    // const [joinDate, setJoinDate] = useState("DD MM YYYY");
    const [loading, setLoading] = useState(false);

   
  

    useEffect(() => {
        // getUser();
    }, []);
// console.log("employeeBasicData==>",employeeBasicData)
// console.log("employeeBasicData?.employee_name ===>",employeeBasicData?.employee_name )
  return(
    <div>
        <div className="card-body p-md-4 p-0">
            <div><h5>Basic Information</h5></div>
            <div className="tab-content">
                <div className="tab-pane active show" id="personalDetails" role="tabpanel">
                        <form action="javascript:void(0);">
                                    <div className="row">
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="firstnameInput" className="form-label">Full Name</label>
                                                        <input value={employeeBasicData?.employee_name || "--"} type="text" className="form-control" id="firstnameInput"  />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="firstnameInput" className="form-label">Date Of Birth</label>
                                                    <input value={employeeBasicData?.date_of_birth? formatDate(employeeBasicData?.date_of_birth):"--" } type="text" className="form-control" id="firstnameInput" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="firstnameInput" className="form-label">Gender</label>
                                                    <input value={employeeBasicData?.employee_gender || "--"} type="text" className="form-control" id="firstnameInput"  />
                                                </div>
                                            </div>
                                        {/*
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="firstnameInput" className="form-label">Official Email ID</label>
                                                    <input value={employeeBasicData?.employee_official_email || "--"} type="text" className="form-control" id="firstnameInput"  />
                                            </div>
                                            </div>*/} 
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="firstnameInput" className="form-label">Current Address</label>
                                                    <input value={employeeBasicData?.employee_address || "--"} type="text" className="form-control" id="firstnameInput" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="firstnameInput" className="form-label">Permanent Address</label>
                                                    <input value={employeeBasicData?.employee_permanent_address || "--"} type="text" className="form-control" id="firstnameInput" />
                                                </div>
                                            </div>
                                            {/* <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="firstnameInput" className="form-label">Status</label>
                                                    <input value={employeeBasicData?.employee_status } type="text" className="form-control" id="firstnameInput" />
                                                </div>                       
                                            </div> */}

                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="phonenumberInput" className="form-label">Phone Number</label>
                                                    <input value={employeeBasicData?.employee_mobile_number || "--"} type="text" className="form-control" id="phonenumberInput" />
                                            </div>
                                            </div>
                                                                {/*end col*/}
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="emailInput" className="form-label">Personal Email</label>
                                                    <input value={employeeBasicData?.employee_email_address || "--"} type="email" className="form-control" id="emailInput" />
                                                </div>
                                            </div>
                                                                {/*end col*/}
                                            {/* <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <label htmlFor="JoiningdatInput" className="form-label">Joining Date</label>
                                                
                                                <div className='form-control flatpickr-input'>
                                                    {employeeBasicData?.employee_joining_date? formatDate(employeeBasicData?.employee_joining_date):"--" }
                                                </div>
                                                </div>
                                            </div> */}
        {/*                                             
                                            <div className="col-lg-6">
                                                                    <div className="mb-3">
                                                                        <label htmlFor="designationInput" className="form-label">Designation</label>
                                                                        <input value={employeeBasicData?.designation_title || "--"} type="text" className="form-control" id="designationInput" />
                                                                    </div>
                                            </div> */}
                                                                
                                                            
                            </div>
                                                        
                        </form>
                </div>                                                                       
            </div>
        </div>                              
    </div>
  );
}

export default BasicInformation